import React, { Component } from 'react'
import { Button, Input, Select } from 'antd'
import get from 'lodash/get'
const { Option } = Select;

export default class TokenForm extends Component {
  onChange = e => {
    this.props.updateByKey(e.target.name, e.target.value)
  }
  onChangeType = v => {
    this.props.updateByKey('isAq', v)
  }
  onSubmit = () => {
    this.props.onSubmit()
  }
  render() {
    return (
      <form action="#" method="POST"> 
        <p style={{ color: 'rgba(0, 0, 0, 0.85)', fontWeight: 'bold', textAlign: 'left' }}>ReferenceNo </p>
        <Input name="referenceNo" value={this.props.data.referenceNo}  maxLength={15} placeholder="ReferenceNo : “201911290001”" onChange={this.onChange} readOnly /><br/>
      
        <br /><br />
        <Button type="primary" onClick={this.onSubmit} block loading={this.props.loading}>Confirm</Button><br/><br/>
      </form>
    )
  }
}
